import React from 'react';
import ReactDOM from 'react-dom';
import AppProvider from 'store/provider';
import wrapPageElementWithTransition from 'helpers/wrapPageElement';
import 'bootstrap/dist/css/bootstrap.css';

// React Context in Browser
// eslint-disable-next-line react/prop-types
export const wrapRootElement = ({ element }) => {
  return <AppProvider>{element}</AppProvider>;
};

// Page Transitions
export const wrapPageElement = wrapPageElementWithTransition;

export const onRouteUpdate = (win) => {
  if (win.location && win.location.hash) {
    setTimeout(() => {
      console.log(
        'onRouteUpdate',
        document.querySelector(`${win.location.hash}`)
      );
      document.querySelector(`${win.location.hash}`) &&
        document.querySelector(`${win.location.hash}`).scrollIntoView(true);
      if (typeof window !== 'undefined') {
        setTimeout(() => {
          window.scrollBy(0, -180);
        }, 30);
      }
    }, 0);
  } else {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500);
  }
};

export const replaceHydrateFunction = () => {
  return (element, container, callback) => {
    ReactDOM.render(element, container, callback);
  };
};
